import React from "react";
import { translate } from "../../../../common/providers";
import styles from "./ConversationPropositions.module.css";
import { CustomButton } from "../../../../common/components";

const ConversationPropositions = ({ onChangeTextFilter }) => {
	const questionCount = 8;
	const questionElements = [];
	for (let i = 1; i <= questionCount; i++) {
		const questionTitle = translate(`ai-chat.conversation-propositions.conversation${i}.title`);
		const questionValue = translate(`ai-chat.conversation-propositions.conversation${i}`);
		questionElements.push(
			<div key={i} className={styles.proposition__container}>
				<div className={styles.proposition_title}>{questionTitle}</div>
				<CustomButton
					size="sm"
					variant="contained"
					onClick={() => onChangeTextFilter(questionValue, questionTitle)}
				>
					{translate("ai-chat.conversation-propositions.select-question")}
				</CustomButton>
			</div>
		);
	}
	return (
		<div className={styles.container}>
			<div className={styles.title}>{translate("ai-chat.conversation-propositions.question.help")}</div>
			<div className={styles.propositions}>{questionElements}</div>
		</div>
	);
};

export default ConversationPropositions;
